import { Outlet, Link, useNavigate, useLocation } from "react-router-dom"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { LogOut } from "lucide-react"
import Navbar from "./Navbar"
import Footer from "./Footer"
import { logout } from "../store/slices/authSlice"


const Layout = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { user, accessToken } = useSelector((s) => s.auth)

    useEffect(() => {
        if (location.hash === "#newsletter") {
            const el = document.getElementById("newsletter")
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" })
        }
    }, [location.pathname, location.hash])
    const isLoggedIn = !!(accessToken && user)

    const handleLogout = () => {
        dispatch(logout())
        navigate("/")
    }

    return (
        <div className="flex flex-col min-h-screen overflow-x-hidden">
            <Navbar />
            <main className={`flex-grow ${isLoggedIn ? 'pt-28 xl:pt-[9.5rem]' : 'pt-20 xl:pt-[7.5rem]'}`}>
                <Outlet />
            </main>
            <Footer />
        </div>
    )
}

export default Layout
